import { useAuth } from './auth'; // Uses Firebase Auth

const useAuthorization = (requiredPermissions = [], requiredAppRoles = [], clientId = null) => {
  const { userDetails } = useAuth();
  const { appPermissions = [], clientPermissions = {} } = userDetails || {};

  // App role validation
  const appRole = userDetails?.appRole || null;

  // // Automatically authorize if the user's role is 'admin'
  // if (appRole === 'admin') {
  //   return {
  //     isAuthorized: true,
  //     hasAppRole: true,
  //     hasClientRole: true, // Admin should have access at both app and client level
  //     loading: false,
  //   };
  // }

  // Check if the user's appRole is included in the requiredAppRoles array
  const hasAppRole = requiredAppRoles.length > 0 
    ? requiredAppRoles.includes(appRole)
    : true; // If no roles are required, we assume the user has the correct role

  // If no clientId is provided, just check app-level permissions
  if (!clientId) {
    const appPermissionsCheck = requiredPermissions.every(permission =>
      appPermissions.includes(permission)
    );
    return {
      isAuthorized: hasAppRole && appPermissionsCheck,
      hasAppRole,
      loading: false,
    };
  }

  // Client-level permission check
  const clientData = clientPermissions[clientId] || {};
  const clientSpecificPermissions = clientData.clientPermissions || [];
  const clientGroups = clientData.clientGroups || [];
  const clientRole = clientData.clientRole || null;

  // User must have a client role to access client-specific resources
  const hasClientRole = Boolean(clientRole);

  // Combine client-specific permissions with permissions from client groups
  const combinedClientPermissions = [
    ...new Set([...clientSpecificPermissions, ...clientGroups.flatMap(group => group.permissions || [])])
  ];

  // Check if client-level permissions are satisfied
  const clientPermissionsCheck = requiredPermissions.every(permission =>
    combinedClientPermissions.includes(permission)
  );

  // If client-level permissions are not sufficient, check app-level permissions
  const appPermissionsCheck = requiredPermissions.every(permission =>
    appPermissions.includes(permission)
  );

  // Final authorization logic:
  const isAuthorized = hasClientRole && (clientPermissionsCheck || appPermissionsCheck);

  return {
    isAuthorized,
    hasAppRole,
    hasClientRole,
    loading: false,
  };
};

export { useAuthorization };
